// extracted by mini-css-extract-plugin
module.exports = {"widgets":"widgets___1xFjJ","widgetsContent":"widgetsContent___3MmiS"};